import { LedgerType } from "@syla/shared/types/models/LedgerBase";
import { TransactionType } from "@syla/shared/types/models/TransactionBase";
import { OrderResponseItem } from "@syla/shared/types/responses/OrderResponseItem";
import { TransactionEvent } from "@syla/shared/types/responses/TransactionEvent";
import { getLedgerTypeIcon } from "./getLedgerType";
import { getTransactionTypeIcon } from "./getTransactionTypeOptions";

export const getOrderIconAndText = (
  orderResponse: OrderResponseItem,
): { icon: string; text: string } => {
  // if more than one transaction in the order, return the order icon
  if (orderResponse.transactions.length > 1)
    return {
      icon: getTransactionTypeIcon("group"),
      text: "Group",
    };

  return getTransactionIconAndText(orderResponse.transactions[0]);
};

export const getTransactionIconAndText = (transaction: {
  type: TransactionEvent["type"];
}): { icon: string; text: string } => {
  return {
    icon:
      transaction.type in TransactionType ?
        getTransactionTypeIcon(transaction.type as TransactionType)
      : getLedgerTypeIcon(transaction.type as LedgerType),
    text: transaction.type,
  };
};
